import { jsxs, jsx } from "react/jsx-runtime";
const IconWarningAmberSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M12 5.99 19.53 19H4.47L12 5.99M12 2 1 21h22L12 2z" }),
      /* @__PURE__ */ jsx("path", { d: "M13 16h-2v2h2zm0-6h-2v5h2z" })
    ]
  }
);
export {
  IconWarningAmberSvg
};
